import defaults from './default.constants';

export const statusConstants = {
  ...defaults.rsf('get', 'status'),
};
